import PageMetaInterface from "../../../interfaces/core/PageMetaInterface";

export default function Header({meta, count}: {meta: PageMetaInterface, count: number})
{
    return (<div className="site-title__wrap">
        {meta?.html_header && <div className="site-title f-exp"><h1 className="site-title__h">{meta?.html_header}
        </h1><sup>{count}</sup></div>}
    </div>)
}